import { DesignLayouts } from 'records/DesignLayout';
import Base from 'records/Base';

import {
  DESIGN_LAYOUTS_ASYNC_ACTION_START,
  DESIGN_LAYOUTS_ASYNC_ACTION_ERROR,
  DESIGN_LAYOUTS_ASYNC_ACTION_SUCCESS,
  DESIGN_LAYOUTS_ASYNC_CHANGE_ACTION_SUCCESS,
  DESIGN_LAYOUTS_RESET_STATE,
} from 'actions/designLayouts';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: DesignLayouts(),
});

const actionsMap = {
  [DESIGN_LAYOUTS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [DESIGN_LAYOUTS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [DESIGN_LAYOUTS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignLayouts(action.data),
    });
  },
  [DESIGN_LAYOUTS_ASYNC_CHANGE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [DESIGN_LAYOUTS_RESET_STATE]: () => {
    return initialState;
  },
}

export default function designLayouts(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
